import { useQuery } from "@tanstack/react-query";
import { updateContentBlockerTemplate } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Update given content blocker template via RCB ContentBlocker API.
 */ function useContentBlockerTemplateEdit(contentBlockerTemplate) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.editContentBlocker(contentBlockerTemplate), ({ signal })=>updateContentBlockerTemplate({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            body: {
                contentBlockerTemplate
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: !!contentBlockerTemplate
    });
}
export { useContentBlockerTemplateEdit };
